import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Router } from 'react-router-dom'
import './config/ReactotronConfig'
import history from './services/history'
import { store, persistor } from './store'
import Routes from 'presentation/routes'
import { createTheme, ThemeProvider } from '@mui/material'
import { deepmerge } from '@mui/utils'
import { defaultTheme } from 'config/themes/defaultTheme'
import { useAtom } from 'jotai'
import { globalThemeAtom } from './config/providers/global/globalTheme'
import { QueryProvider } from '@/config/providers'

function App() {
  const [globalTheme] = useAtom(globalThemeAtom)
  const theme = createTheme(deepmerge(defaultTheme, { palette: { brand: globalTheme?.palette?.brand } }))
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <QueryProvider>
            <Router history={history}>
              <Routes />
            </Router>
          </QueryProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  )
}
export default App
